import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['gray-light', 'blue-light']),
};

const BoxedItem = ({ className, color, children }) => {
  const classes = classNames({
    'boxed-item': true,
    [`boxed-item-${color}`]: !!color,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

BoxedItem.propTypes = propTypes;

export default BoxedItem;
